import {
  AwardIcon,
  Clock3Icon,
  HelpCircleIcon,
  RepeatIcon,
  TrendingDownIcon,
  UsersIcon,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export interface PainPoint {
  icon: LucideIcon
  text: string
}

export const painPoints: PainPoint[] = [
  { icon: HelpCircleIcon, text: 'Dopiero zaczynasz trenować i nie wiesz, od czego zacząć.' },
  { icon: RepeatIcon, text: 'Powtarzasz ciągle te same ćwiczenia, a zawodnicy się nudzą.' },
  { icon: UsersIcon, text: 'Jesteś nauczycielem WF, który musi prowadzić siatkówkę bez specjalizacji.' },
  { icon: Clock3Icon, text: 'Nie masz czasu, żeby planować każdy tydzień.' },
  { icon: TrendingDownIcon, text: 'Twój zespół stoi w miejscu i nie robi postępów.' },
  { icon: AwardIcon, text: 'Chcesz wyglądać profesjonalnie przed rodzicami i klubem.' },
]
